/**
 * Global icon defaults.
 *
 * Brand guidelines §05: outlined icons, 1.75px stroke, rounded corners — lucide's
 * default is 2px. Set once through the library's own provider so no call site has to
 * remember it and every icon in the app agrees.
 *
 * `absoluteStrokeWidth` stays off deliberately: it holds the stroke visually constant
 * as icons scale, which reads as heavier at the 12px sizes used in badges and chips.
 */

import type { ReactNode } from 'react';
import { LucideProvider } from 'lucide-react';

export function IconContext({ children }: { children: ReactNode }) {
  return (
    <LucideProvider strokeWidth={1.75} absoluteStrokeWidth={false}>
      {children}
    </LucideProvider>
  );
}
